import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { ThemeProvider, CssBaseline } from "@material-ui/core";
import themeWithResponsiveFonts from "./theme";
import "./globalStyles.css";

import * as serviceWorker from "./serviceWorker";

// Function to completely remove white background sections
const fixWhiteBackgrounds = () => {
  // Find and completely remove top-parallax sections from DOM
  const whiteSections = document.querySelectorAll('section.top-parallax, section[class*="top-parallax"], .top-parallax');
  whiteSections.forEach((section: Element) => {
    const htmlSection = section as HTMLElement;
    // Completely remove the element from DOM
    try {
      if (htmlSection.parentNode) {
        htmlSection.parentNode.removeChild(htmlSection);
      }
    } catch (e) {
      // If removal fails, at least hide it
      htmlSection.style.display = 'none';
      htmlSection.style.visibility = 'hidden';
      htmlSection.style.height = '0';
      htmlSection.style.padding = '0';
      htmlSection.style.margin = '0';
    }
  });
};

ReactDOM.render(
  <React.StrictMode>
    <div style={{ backgroundColor: "#02162b", minHeight: "100vh", width: "100%", margin: 0, padding: 0 }}>
      <ThemeProvider theme={themeWithResponsiveFonts}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </div>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    // Run after render
    fixWhiteBackgrounds();
    setTimeout(fixWhiteBackgrounds, 100);
    setTimeout(fixWhiteBackgrounds, 500);
    setTimeout(fixWhiteBackgrounds, 1000);
  }
);

// Also run after DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixWhiteBackgrounds);
} else {
  fixWhiteBackgrounds();
}

// Run periodically to catch dynamically added elements
setInterval(fixWhiteBackgrounds, 2000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

